<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="等级名称">
        <el-input style="width: 177px" v-model="queryForm.gradeName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getMppPromoterGradeList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addMppPromoterGrade">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editMppPromoterGrade(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteMppPromoterGrade(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportMppPromoterGradeList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshMppPromoterGradeList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="mppPromoterGradeList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="gradeName" label="等级名称" min-width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="grade" label="等级数值" min-width="180">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="promoteShopRatio" label="推广店铺收益比例"
        min-width="180"> </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" align="center" prop="promoteStoreRatio" label="推广门店收益比例"
        min-width="180"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" min-width="180">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" min-width="300">
          <template slot-scope="scop">
            <div class="operation">
              <!-- <div @click="checkMppPromoterGrade(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div> -->
              <div @click="editMppPromoterGrade(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteMppPromoterGrade(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="mppPromoterGradeStates[mppPromoterGradeState]" :visible.sync="showDialog" width="60%"
        @close="closeDialog">
        <div>
          <el-form :model="mppPromoterGrade" ref="mppPromoterGradeForm" :rules="rules" label-width="146px" :inline="true"
            size="small">
            <el-form-item label="等级名称" prop="grade">
              <!-- <el-input style="width: 177px" size="small" v-model="mppPromoterGrade.gradeName"
                :disabled="mppPromoterGradeState == 'check'"></el-input> -->
                <el-select
                    style="width: 177px;"
                    v-model='mppPromoterGrade.grade'
                    size='small'
                    placeholder='等级名称'
                    :disabled="mppPromoterGradeState == 'check'"
                >
                    <el-option v-for='(item,index) in currencyTypeEnumList' :label='item.value'
                                :value='item.key'></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="推广门店收益比例" prop="promoteShopRatio">
              <el-input style="width: 177px" size="small" v-model="mppPromoterGrade.promoteShopRatio"
                :disabled="mppPromoterGradeState == 'check'"></el-input>
            </el-form-item> -->
            <el-form-item label="推广门店收益比例" prop="promoteStoreRatio">
              <el-input style="width: 177px" size="small" v-model="mppPromoterGrade.promoteStoreRatio"
                :disabled="mppPromoterGradeState == 'check'"></el-input>
            </el-form-item>
            <el-form-item v-show="mppPromoterGradeState == 'check'" label="创建时间" prop="createTime">
              <el-input style="width: 177px" size="small" v-model="mppPromoterGrade.createTime"
                :disabled="mppPromoterGradeState == 'check'"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="mppPromoterGradeState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetMppPromoterGradeList();
        this.getMppPromoterGradeList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetMppPromoterGradeList();
        this.getMppPromoterGradeList();
        this.$emit('resetCheckState');
      }
    }
  },
  data() {
    return {
      queryForm: {
        id: '', //ID
        gradeName: '', //等级名称
        promoteShopRatio: '', //推广门店收益比例
        promoteStoreRatio: '', //推广门店收益比例
        createUserId: '', //创建人
        updateUserId: '', //更新人
        createTime: '', //创建时间
        updateTime: '', //更新时间
        deleteFlag: '', //是否删除 0未删除 1 删除
      },
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      mppPromoterGradeState: 'add',
      mppPromoterGradeStates: {
        add: '新建等级',
        check: '查看等级',
        edit: '修改等级'
      },
      currencyTypeEnumList:[],
      multipleSelection: [],
      mppPromoterGradeList: [],
      mppPromoterGrade: {
        id: '', //ID
        gradeName: '', //等级名称
        promoteShopRatio: '', //推广门店收益比例
        promoteStoreRatio: '', //推广门店收益比例
        createUserId: '', //创建人
        updateUserId: '', //更新人
        createTime: '', //创建时间
        updateTime: '', //更新时间
        deleteFlag: '', //是否删除 0未删除 1 删除
      },
      btnLoading: false,

      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        gradeName: [{ required: true, message: '等级名称不能为空', trigger: 'blur' }],
        promoteShopRatio: [{ required: true, message: '推广门店收益比例不能为空', trigger: 'blur' }],
        promoteStoreRatio: [{ required: true, message: '推广门店收益比例不能为空', trigger: 'blur' }],
        createUserId: [{ required: true, message: '创建人不能为空', trigger: 'blur' }],
        updateUserId: [{ required: true, message: '更新人不能为空', trigger: 'blur' }],
        updateTime: [{ required: true, message: '更新时间不能为空', trigger: 'blur' }],
        deleteFlag: [{ required: true, message: '是否删除 0未删除 1 删除不能为空', trigger: 'blur' }],
      }
    };
  },
  created() {
    this.getMppPromoterGradeList();
    this.getCurrencyType();
  },
  methods: {
     //获取currency_type枚举
     getCurrencyType() {
        get('/mpp/utils/getEnum', {
            enumType: 'promoter_grade'
        }).then((res) => {
            this.currencyTypeEnumList = res.enumList;
        });
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetMppPromoterGradeList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.mppPromoterGradeList = [];
    },
    resetDialog() {
      this.mppPromoterGradeState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        gradeName: '', //等级名称
        promoteShopRatio: '', //推广门店收益比例
        promoteStoreRatio: '', //推广门店收益比例
        createUserId: '', //创建人
        updateUserId: '', //更新人
        createTime: '', //创建时间
        updateTime: '', //更新时间
        deleteFlag: '', //是否删除 0未删除 1 删除
      };
      this.getMppPromoterGradeList();
    },
    closeDialog() {
      this.showDialog = false
      this.mppPromoterGrade = {
        id: '', //ID
        gradeName: '', //等级名称
        promoteShopRatio: '', //推广门店收益比例
        promoteStoreRatio: '', //推广门店收益比例
        createUserId: '', //创建人
        updateUserId: '', //更新人
        createTime: '', //创建时间
        updateTime: '', //更新时间
        deleteFlag: '', //是否删除 0未删除 1 删除
      };
    },
    submitForm() {
      if (this.mppPromoterGradeState == 'add') {
        this.$refs.mppPromoterGradeForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/promotergrade/add`, { ...this.mppPromoterGrade }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetMppPromoterGradeList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.mppPromoterGradeState == 'edit') {
        this.$refs.mppPromoterGradeForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/promotergrade/edit`, { ...this.mppPromoterGrade }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetMppPromoterGradeList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addMppPromoterGrade() {
      this.showDialog = true;
      this.mppPromoterGradeState = 'add';
    },
    checkMppPromoterGrade(mppPromoterGradeId) {
      console.log(mppPromoterGradeId);
      this.currentMppPromoterGradeId = mppPromoterGradeId;

      this.getMppPromoterGradeById();
      this.showDialog = true;
      this.mppPromoterGradeState = 'check';
    },
    editMppPromoterGrade(mppPromoterGradeId) {
      console.log('mppPromoterGrade', mppPromoterGradeId);
      if (mppPromoterGradeId) {
        this.currentMppPromoterGradeId = mppPromoterGradeId;
        this.getMppPromoterGradeById();
      } else {
        this.mppPromoterGrade = { ...this.mppPromoterGrade, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.mppPromoterGradeState = 'edit';
    },
    deleteMppPromoterGrade(mppPromoterGradeId) {
      let ids = '';
      if (mppPromoterGradeId) {
        ids = mppPromoterGradeId;
      } else {
        ids = this.multipleSelection.map((mppPromoterGrade) => mppPromoterGrade.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/mpp/promotergrade/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetMppPromoterGradeList();
              this.getMppPromoterGradeList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshMppPromoterGradeList() {
      this.resetMppPromoterGradeList();
      this.getMppPromoterGradeList();
    },
    getMppPromoterGradeList(query = {}) {
      this.loading = true;
      get(`/mpp/promotergrade/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.mppPromoterGradeList = res.page.list;
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getMppPromoterGradeById() {
      get(`/mpp/promotergrade/get`, { id: this.currentMppPromoterGradeId }).then((res) => {
        if (res.success) {
          this.mppPromoterGrade = { ...this.mppPromoterGrade, ...res.mppPromoterGrade };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportMppPromoterGradeList() {
      //this.btnLoading = true;
      exprotExcel(`/mpp/promotergrade/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/mpp/promotergrade/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/mpp/promotergrade/importData`, formData);
      this.refreshMppPromoterGradeList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getMppPromoterGradeList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getMppPromoterGradeList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>